import { Group, Space } from '@mantine/core';
import { PortalButton } from 'components/Button/PortalButton';
import { TableAction } from 'utils/models';

interface Props {
  actions: TableAction[];
  selectedRows?: string[];
  selectedIds: () => string[];
}

export const TableActions = ({ actions, selectedRows = [], selectedIds }: Props) => {
  if (selectedRows.length > 0) {
    return (
      <Group gap={'xs'}>
        {actions.map(({ icon, label, onClick, isUpdating, limit, disabledTooltip }: TableAction, index) => {
          const reachedSelectLimit = limit !== undefined && selectedRows.length > limit;
          const isDisabled = isUpdating || reachedSelectLimit;
          return (
            <PortalButton
              key={index}
              label={label}
              size={'xs'}
              Icon={icon}
              onClick={() => onClick(selectedIds())}
              disabled={isDisabled}
              badgeNumber={selectedRows.length}
              badgeNumberLimit={limit}
              tooltip={isDisabled && disabledTooltip ? { label: disabledTooltip } : undefined}
            />
          );
        })}
      </Group>
    );
  }
  // The 30 is to match the PortalButton to the pixel when selecting rows
  return <Space h={30} />;
};
